import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  button: {
    borderRadius: '50%',
    color: 'white',
    backgroundColor: theme.palette.primary.main,
    height: 28,
    width: 28,
    display: 'flex',
    alignItems: 'center',
    border: '0',
    cursor: 'pointer',
    flexDirection: 'column',
    justifyContent: 'center',
    outline: '0'
  }
}))

export default useStyles
